import { useState } from "react";
// import { allposts } from "../posts"; // HIDE legacy static posts
import SanityBlogCards from "../blog/SanityBlogStrip"; // strip accepts { category }
import PressCards from "../components/PressCards";
import Title from "../components/typography/Title";
import ResourcesSection from "../components/Resources/HeroSection";
import JoinUs from "../components/JoinUs";
import SanityCustomerGalleryStrip from "../blog/SanityCustomerGalleryStrip";


type Pill = "All" | "AI" | "Product" | "Blogs" | "News";

function Resources() {
  const [selectedCategory, setSelectedCategory] = useState<Pill>("All");

  const CATEGORIES: readonly Pill[] = [
    "All",
    "AI",
    "Product",
    // "Customer Gallery",
    "Blogs",
    "News",
  ];

  // Pills that should render Sanity content
  const SHOW_SANITY: readonly Pill[] = [
    "All",
    "AI",
    "Product",
    "Blogs",
    "News",
    // "Customer Gallery",
  ];

  return (
    <main className="flex w-screen flex-col px-4 py-5">
      <div className="z-10 mb-10 box-border flex w-full flex-col justify-around overflow-hidden text-white">
        <ResourcesSection from="resources" />
      </div>

      <Title size="xl">Categories</Title>
      {/* Pills bar (now 6 options) */}
      <div className="mt-10 inline-flex w-full flex-row items-center justify-center gap-4">
        {CATEGORIES.map((label) => (
          <button
            key={label}
            className={`flex cursor-pointer justify-center whitespace-nowrap rounded-full border-none px-3 py-2 text-base text-white md:px-4 ${
              selectedCategory === label
                ? "bg-orange-700 opacity-100"
                : "bg-gray-700 hover:bg-app-700/40"
            }`}
            onClick={() => setSelectedCategory(label)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Sanity grid filtered by the selected pill */}
      {SHOW_SANITY.includes(selectedCategory) && (
        <div className="mt-[50px] w-full px-2 md:px-6">
          <SanityBlogCards category={selectedCategory as any} />
        </div>
      )}

      {selectedCategory === "News" && <PressCards />}

      <JoinUs />
    </main>
  );
}

export default Resources;
